import _mock from "../_mock";

export const _orderReview = [...Array(5)].map((_, index) => ({
  id: _mock.id(index),
  price: "100",
  payment_way: "cash",
  order_rate: _mock.number.rating(index),
  order_review: "Great food ...View More",
}));

export const _currentOrders = [...Array(24)].map((_, index) => ({
  invoice_num: _mock.id(index),
  order_time: "12 : 45 A.M",
  location: truncate(_mock.address.fullAddress(index), 15),
  meals: Math.trunc(_mock.number.price(index) * 0.5),
  price: Math.trunc(_mock.number.price(index) * 2),
  customer_name: _mock.name.firstName(index),
  delivery_name: _mock.name.lastName(index),
  phone: _mock.phoneNumber(index),
}));

export const _mostOrders = [...Array(24)].map((_, index) => ({
  meal_id: _mock.id(index),
  meal_name: "Meal Name",
  orders_count: _mock.number.age(index) * 2,
  order_ratio: Math.trunc(_mock.number.percent(index)),
  meal_rate: _mock.number.rating(index),
}));

//-----------------------------------------------

// truncate function to trim string to specific length
function truncate(string, n) {
  return string?.length > n ? string.substr(0, n) + "..." : string;
}
